import { AT_SHOW_SET, ICookieDialogShowSetAction } from './types';

export const showSet = (
    isShow: boolean
): ICookieDialogShowSetAction => ({
    type: AT_SHOW_SET,
    isShow: isShow
});
